import { call, put, select, takeLatest } from 'redux-saga/effects'
import { DRAW } from './constants';
import { endDraw, } from './actions';
import gameTurnService from '../services/gameTurn';
import { handleUpdateGame } from '../ActiveGame/sagas';
import { selectActiveGame } from '../ActiveGame/selectors';
import { closeContextMenu } from '../ActiveGame/actions';

function* drawTask() {
  const gameId = (yield select(selectActiveGame)).get('id');
  const game = yield call(gameTurnService.draw, gameId);

  yield call(handleUpdateGame, game);

  yield put(endDraw());

  // The hand is always on screen, so the new card shows there.
  yield put(closeContextMenu());
}

function* drawWatcher() {
  yield takeLatest(DRAW, drawTask);
}

export default [
  drawWatcher,
];
